import { Colors } from "@/enums/Colors";
import { Box, SxProps, Typography, styled } from "@mui/material";
import EmptyScreenSVG from "../../../assets/images/empty-notifications.svg";
import { EmptyScreenImg } from "./DataRoomEmptyManageScreen";

type Props = {
  imageSx?: SxProps;
  containerSx?: SxProps;
  subtext?: string;
};

function DataRoomRedFlagsEmptyScreen(props: Props) {
  return (
    <>
      <MainContainer sx={{ ...props.containerSx }}>
        <EmptyScreenImg sx={{ ...props.imageSx }} alt="empty-screen" src={EmptyScreenSVG.src} />
        <Box className="text-container">
          <Typography fontSize="0.875rem" fontWeight="600" lineHeight="20px">
            No red flags
          </Typography>
          <Typography color={Colors.LIGHT_GRAY_8A8E93} fontSize="0.875rem" fontWeight="400" lineHeight="19.6px">
            {props.subtext ? props.subtext : "No red flags here yet"}
          </Typography>
        </Box>
      </MainContainer>
    </>
  );
}

const MainContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "1.983rem 0",
  gap: "1rem",
  height: "100%",
  width: "100%",
  "& .text-container": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    width: "100%",
    gap: "0.5rem",
  },
}));

export default DataRoomRedFlagsEmptyScreen;
